import { SDKAction, sdk } from "@squareup/sq-addons-web-sdk";

import { useEffect } from "react";
import { Router, Switch, Route, useParams } from 'react-router-dom';
import { createBrowserHistory } from 'history';


const DEFAULT_ADDON_NAME = 'LAVA Loyalty';

const history = createBrowserHistory();

const RegisterCallback = () => {
  const {addonName} = useParams() as {addonName?: string};

  useEffect(() => {
    const registerGetAddonInfoCallback = async () => {    
      const callbacks = {
        [SDKAction.SDK_GET_ADDON_INFO]: () => ({ title: `${addonName ?? DEFAULT_ADDON_NAME}` }),
      };
      //@ts-ignore
      await sdk.initialize(callbacks);
    };

    registerGetAddonInfoCallback();
  }, []);

  return <></>;
}

const ActionSlot = () => {
  return (
    <Router history={history}>
        <Switch>
          <Route path="/addonName/:addonName">
            <RegisterCallback />
          </Route>
          
          <Route path="/">
            <RegisterCallback />
          </Route>
        </Switch>
      </Router>
  );
};

export default ActionSlot;
